import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Storage.module.css';

import { useGetSettingsStorageQuery } from '../../../services/settings';

import { StorageItem } from '../../../types/settings';
import { PURCHASE, SELPUB_CLOUD_USAGE, STORAGE } from '../../../constants';
import List from './List/List';

import { useDispatch } from 'react-redux';
import { storageChanged } from '../../../features/storageSlice';

export default function Storage() {
  const cx = classNames.bind(styles);
  const dispatch = useDispatch();

  const { data: storageData, isLoading } = useGetSettingsStorageQuery();
  const [listData, setListData] = useState({});

  const storageList = ['libraryList', 'archiveList', 'trashList'];

  useEffect(() => {
    if (storageData) {
      const totalList = storageList.reduce(
        (acc: StorageItem[], name) => [...acc, ...storageData[name]],
        []
      );
      const { libraryList, archiveList, trashList, totalSize, limitSize } =
        storageData;
      setListData({ totalList, libraryList, archiveList, trashList });
      dispatch(storageChanged({ used: totalSize, limit: limitSize }));
    }
  }, [storageData]);

  if (isLoading) return null;

  return (
    <>
      <h2>{STORAGE}</h2>
      <p className={cx('fs18', 'tac')}>{SELPUB_CLOUD_USAGE}</p>
      <ul className={cx('drive_list')}>
        {Object.entries(listData).map(([name, list]: [string, any]) => (
          <List key={name} name={name} list={list} data={storageData} />
        ))}
      </ul>

      {/* <div className={cx('btn_wrap', 'bottom')}>
        <button type="button" className={cx('btn', 'b_t', 's48')}>
          <span>
            {STORAGE} {PURCHASE}
          </span>
        </button>
      </div> */}
    </>
  );
}
